export default __webpack_public_path__ + "static/illustration-video-map-d381aea21877d83ec8a6c5ac908d0387.jpg";